import { Heart, Code, Rocket } from 'lucide-react'

function Footer() {
  return (
    <footer className="relative bg-gray-950/50 backdrop-blur-xl border-t border-cyan-500/20 py-12 sm:py-16">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-t from-gray-950/80 to-transparent pointer-events-none"></div>
      <div className="absolute inset-0 bg-cyber-grid bg-cyber-grid opacity-10 pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2 animate-fade-in-up">
            <div className="flex items-center space-x-3 mb-6">
              <div className="relative p-2 bg-gradient-to-br from-cyan-500/20 to-purple-600/20 backdrop-blur-xl rounded-2xl border border-cyan-500/30">
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-purple-600/10 rounded-2xl animate-pulse-glow"></div>
                <Rocket className="w-6 h-6 text-cyan-400 relative z-10" />
              </div>
              <h3 className="text-2xl font-bold text-white font-display neon-text">FixSlop.xyz</h3>
            </div>
            <p className="text-gray-300 mb-6 max-w-md text-base leading-relaxed">
              The fastest way to create <span className="text-cyan-400 font-semibold">professional</span> memecoin landing pages. 
              <span className="text-purple-400 font-semibold"> AI-powered</span>, customizable, and ready to launch in 
              <span className="text-green-400 font-semibold"> minutes</span>.
            </p>
            <div className="flex items-center text-gray-400 text-sm">
              <span>Made with</span>
              <Heart className="w-4 h-4 mx-2 text-red-400 animate-bounce-gentle" />
              <span>and</span>
              <Code className="w-4 h-4 mx-2 text-cyan-400 animate-bounce-gentle" />
              <span>for the crypto community</span>
            </div>
          </div>
          
          {/* Features */}
          <div className="animate-fade-in-up" style={{animationDelay: '0.2s'}}>
            <h4 className="text-lg font-semibold mb-6 text-cyan-300 font-display">Features</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-cyan-400 transition-colors duration-300 cursor-pointer">
                AI-Powered Generation
              </li>
              <li className="hover:text-cyan-400 transition-colors duration-300 cursor-pointer">
                Live Preview
              </li>
              <li className="hover:text-cyan-400 transition-colors duration-300 cursor-pointer">
                Custom Domains
              </li>
              <li className="hover:text-cyan-400 transition-colors duration-300 cursor-pointer">
                Mobile Optimized
              </li>
            </ul>
          </div>
          
          {/* Support */}
          <div className="animate-fade-in-up" style={{animationDelay: '0.4s'}}>
            <h4 className="text-lg font-semibold mb-6 text-purple-300 font-display">Support</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-purple-400 transition-colors duration-300 cursor-pointer">
                Documentation
              </li>
              <li className="hover:text-purple-400 transition-colors duration-300 cursor-pointer">
                Help Center
              </li>
              <li className="hover:text-purple-400 transition-colors duration-300 cursor-pointer">
                Contact Us
              </li>
              <li className="hover:text-purple-400 transition-colors duration-300 cursor-pointer">
                Status Page
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="border-t border-cyan-500/20 mt-12 pt-8 text-center">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-gray-400 text-sm">
              &copy; 2025 SiteGen. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <a href="#privacy" className="hover:text-cyan-400 transition-colors duration-300">
                Privacy Policy
              </a>
              <a href="#terms" className="hover:text-cyan-400 transition-colors duration-300">
                Terms of Service
              </a>
              <a href="#cookies" className="hover:text-cyan-400 transition-colors duration-300">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 